import * as docudocumentationChangeSeverity from 'constants/enums/documentationChangeSeverity'

export default {
  [docudocumentationChangeSeverity.BIG]: 'Velká',
  [docudocumentationChangeSeverity.MEDIUM]: 'Střední',
  [docudocumentationChangeSeverity.NONE]: 'Žádná',
}
